import React from 'react';
import { CheckCircle, Shield, Zap, Leaf } from 'lucide-react';
const badges = [{
  icon: CheckCircle,
  label: 'Licensed Waste Carrier',
  sub: 'EA Registered'
}, {
  icon: Shield,
  label: 'Fully Insured',
  sub: 'Public Liability Cover'
}, {
  icon: Zap,
  label: 'Same-Day Options',
  sub: 'Available 7 days'
}, {
  icon: Leaf,
  label: 'Eco-Friendly Disposal',
  sub: '90%+ recycling rate'
}];
export function TrustBadges() {
  return <div className="bg-white border-b border-gray-100 py-6" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-191">
          {badges.map(({
          icon: Icon,
          label,
          sub
        }) => <div key={label} className="flex items-center gap-3" data-id="element-192">
              <Icon className="w-6 h-6 flex-shrink-0" style={{
            color: '#1B8F4B'
          }} data-id="element-193" />
              <div data-id="element-194">
                <p className="text-sm font-bold text-gray-800" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-195">
                  {label}
                </p>
                <p className="text-xs text-gray-500" data-id="element-196">{sub}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}